import { createSlice } from '@reduxjs/toolkit';

import { ADMIN_CONFIG_TABS, ADMIN_CONFIG_TASK_TABS } from './common/constants';
import { type AdminConfigTabs, type AdminConfigTaskTabs } from './common/types';

interface AdminConfigState {
  selectedTab: AdminConfigTabs;
  selectedTaskTab: AdminConfigTaskTabs;
}

const initialState: AdminConfigState = {
  selectedTab: ADMIN_CONFIG_TABS.Site,
  selectedTaskTab: ADMIN_CONFIG_TASK_TABS.Task,
};

const { reducer, actions } = createSlice({
  name: 'adminConfigPageSlice',
  initialState,
  reducers: {
    setSelectedTab: (state, action) => {
      state.selectedTab = action.payload;
    },
    setSelectedTaskTab: (state, action) => {
      state.selectedTaskTab = action.payload;
    },
  },
});

// **** Export **** //

export const { setSelectedTab, setSelectedTaskTab } = actions;
export default reducer;
